export class FABCookie {

    /** Set Cookie */
    static setCookie(name, value, daysToLive = 30, path = '/') {
        /** Set Cookie */
        let cookies = [ [name, value], ['path', path] ];
        if(daysToLive) cookies.push( ['max-age', (daysToLive*24*60*60) ] )
        document.cookie = cookies.map((cookie) => cookie.join('=') ).join(';');
    }

    /** Get Cookie */
    static getCookie(name) {
        let data = null;
        document.cookie.split(";").some((e) => {
            let cookie = e.split('=');
            if(cookie[0].replace(' ','')===name){
                data = cookie[1]; return true; }
        });
        return data;
    }

}